<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcContractPaymentTermsEditor',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
    value: {
      type: Object,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const contractPaymentTermTypes = ref(null);
  const ux = ref([]);

  const $data = computed(() => ({
    contractPaymentTermTypes: contractPaymentTermTypes.value,
    ux: ux.value,
  }));

  const $$load_contractPaymentTermTypes = () => {
    return $fn.value.getEnumValuesFromSchema('ContractPaymentTermTypes');
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'contractPaymentTermTypes' }, { name: 'ux' }],
    loaders: { contractPaymentTermTypes: $$load_contractPaymentTermTypes },
    ux: {},
    dataRefs: { contractPaymentTermTypes, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.value,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('value');
    }
  );

  const act_7315092382398562_reloadComponentData_gshnj90i9 =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_rojsw9hde =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_gshnj90i9,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_rojsw9hde],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_rojsw9hde,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_rojsw9hde = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_rojsw9hde.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <div class="input-group">
      <ItpFormInput
        type="number"
        name="payment_terms_value"
        v-model="value.value"
      >
      </ItpFormInput>
      <ItpFormNativeSelect
        name="payment_terms_type"
        v-model="value.type"
        :options="contractPaymentTermTypes"
      >
      </ItpFormNativeSelect>
    </div>
  </ItpUsercontrol>
</template>
